import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DateTime } from 'luxon';
import { groupArrayByIndexMulti } from '../../../../../../helpers/array';

@Component({
    selector: 'app-kstats',
    templateUrl: './kstats.component.html',
    styleUrls: ['./kstats.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KstatsComponent implements OnInit {
  activity = [
    {
      ctn: 2,
      d: '29-09-2022',
    },
    {
      ctn: 22,
      d: '13-04-2023',
    },
    {
      ctn: 28,
      d: '14-04-2023',
    },
    {
      ctn: 9,
      d: '30-09-2022',
    },
    {
      ctn: 1,
      d: '04-10-2022',
    },
    {
      ctn: 3,
      d: '06-10-2022',
    },
    {
      ctn: 1,
      d: '16-10-2022',
    },
    {
      ctn: 1,
      d: '20-10-2022',
    },
    {
      ctn: 1,
      d: '06-11-2022',
    },
    {
      ctn: 45,
      d: '25-04-2023',
    },
    {
      ctn: 1,
      d: '14-11-2022',
    },
    {
      ctn: 1,
      d: '24-01-2023',
    },
    {
      ctn: 2,
      d: '28-01-2023',
    },
    {
      ctn: 1,
      d: '30-01-2023',
    },
    {
      ctn: 3,
      d: '03-02-2023',
    },
    {
      ctn: 1,
      d: '24-02-2023',
    },
    {
      ctn: 1,
      d: '09-03-2023',
    },
    {
      ctn: 1,
      d: '09-11-2023',
    },
    {
      ctn: 6,
      d: '14-03-2023',
    },
    {
      ctn: 1,
      d: '15-03-2023',
    },
    {
      ctn: 3,
      d: '11-04-2023',
    },
    {
      ctn: 20,
      d: '10-05-2023',
    },
    {
      ctn: 6,
      d: '12-04-2023',
    },
    {
      ctn: 44,
      d: '17-04-2023',
    },
    {
      ctn: 19,
      d: '03-10-2023',
    },
    {
      ctn: 31,
      d: '18-04-2023',
    },
    {
      ctn: 24,
      d: '04-10-2023',
    },
    {
      ctn: 27,
      d: '31-10-2023',
    },
    {
      ctn: 57,
      d: '20-04-2023',
    },
    {
      ctn: 14,
      d: '19-04-2023',
    },
    {
      ctn: 16,
      d: '26-04-2023',
    },
    {
      ctn: 15,
      d: '27-04-2023',
    },
    {
      ctn: 15,
      d: '04-05-2023',
    },
    {
      ctn: 19,
      d: '05-05-2023',
    },
    {
      ctn: 26,
      d: '08-05-2023',
    },
    {
      ctn: 2,
      d: '09-05-2023',
    },
    {
      ctn: 45,
      d: '11-05-2023',
    },
    {
      ctn: 61,
      d: '05-06-2023',
    },
    {
      ctn: 46,
      d: '12-05-2023',
    },
    {
      ctn: 6,
      d: '06-06-2023',
    },
    {
      ctn: 24,
      d: '14-05-2023',
    },
    {
      ctn: 45,
      d: '15-05-2023',
    },
    {
      ctn: 46,
      d: '16-05-2023',
    },
    {
      ctn: 6,
      d: '13-07-2023',
    },
    {
      ctn: 21,
      d: '28-07-2023',
    },
    {
      ctn: 62,
      d: '18-05-2023',
    },
    {
      ctn: 24,
      d: '17-05-2023',
    },
    {
      ctn: 1,
      d: '14-07-2023',
    },
    {
      ctn: 41,
      d: '22-05-2023',
    },
    {
      ctn: 4,
      d: '19-05-2023',
    },
    {
      ctn: 11,
      d: '18-07-2023',
    },
    {
      ctn: 1,
      d: '25-05-2023',
    },
    {
      ctn: 13,
      d: '12-06-2023',
    },
    {
      ctn: 11,
      d: '13-06-2023',
    },
    {
      ctn: 39,
      d: '14-06-2023',
    },
    {
      ctn: 18,
      d: '16-06-2023',
    },
    {
      ctn: 1,
      d: '19-06-2023',
    },
    {
      ctn: 1,
      d: '20-06-2023',
    },
    {
      ctn: 4,
      d: '21-06-2023',
    },
    {
      ctn: 19,
      d: '22-06-2023',
    },
    {
      ctn: 504,
      d: '25-06-2023',
    },
    {
      ctn: 133,
      d: '28-06-2023',
    },
    {
      ctn: 9,
      d: '27-06-2023',
    },
    {
      ctn: 322,
      d: '26-06-2023',
    },
    {
      ctn: 7,
      d: '29-06-2023',
    },
    {
      ctn: 11,
      d: '03-07-2023',
    },
    {
      ctn: 1,
      d: '06-07-2023',
    },
    {
      ctn: 3,
      d: '11-07-2023',
    },
    {
      ctn: 10,
      d: '17-07-2023',
    },
    {
      ctn: 18,
      d: '20-07-2023',
    },
    {
      ctn: 1,
      d: '05-09-2023',
    },
    {
      ctn: 12,
      d: '24-07-2023',
    },
    {
      ctn: 7,
      d: '25-07-2023',
    },
    {
      ctn: 7,
      d: '26-07-2023',
    },
    {
      ctn: 11,
      d: '27-07-2023',
    },
    {
      ctn: 1,
      d: '01-08-2023',
    },
    {
      ctn: 1,
      d: '02-08-2023',
    },
    {
      ctn: 2,
      d: '03-08-2023',
    },
    {
      ctn: 3,
      d: '07-08-2023',
    },
    {
      ctn: 2,
      d: '08-08-2023',
    },
    {
      ctn: 1,
      d: '09-08-2023',
    },
    {
      ctn: 16,
      d: '10-08-2023',
    },
    {
      ctn: 5,
      d: '11-08-2023',
    },
    {
      ctn: 3,
      d: '21-08-2023',
    },
    {
      ctn: 2,
      d: '22-08-2023',
    },
    {
      ctn: 1,
      d: '26-08-2023',
    },
    {
      ctn: 1,
      d: '29-08-2023',
    },
    {
      ctn: 3,
      d: '02-09-2023',
    },
    {
      ctn: 2,
      d: '03-09-2023',
    },
    {
      ctn: 2,
      d: '14-09-2023',
    },
    {
      ctn: 1,
      d: '19-09-2023',
    },
    {
      ctn: 1,
      d: '30-09-2023',
    },
    {
      ctn: 15,
      d: '05-10-2023',
    },
    {
      ctn: 1,
      d: '09-10-2023',
    },
    {
      ctn: 2,
      d: '13-10-2023',
    },
    {
      ctn: 1,
      d: '17-10-2023',
    },
    {
      ctn: 2,
      d: '25-10-2023',
    },
    {
      ctn: 6,
      d: '26-10-2023',
    },
    {
      ctn: 26,
      d: '30-10-2023',
    },
    {
      ctn: 26,
      d: '02-11-2023',
    },
    {
      ctn: 1,
      d: '07-11-2023',
    },
    {
      ctn: 1,
      d: '15-11-2023',
    },
    {
      ctn: 30,
      d: '16-11-2023',
    },
    {
      ctn: 2,
      d: '23-11-2023',
    },
    {
      ctn: 1,
      d: '24-11-2023',
    },
    {
      ctn: 1,
      d: '27-11-2023',
    },
    {
      ctn: 10,
      d: '28-11-2023',
    },
    {
      ctn: 36,
      d: '20-12-2023',
    },
    {
      ctn: 1,
      d: '29-11-2023',
    },
    {
      ctn: 4,
      d: '04-12-2023',
    },
    {
      ctn: 8,
      d: '06-12-2023',
    },
    {
      ctn: 9,
      d: '29-12-2023',
    },
    {
      ctn: 77,
      d: '02-01-2024',
    },
    {
      ctn: 20,
      d: '03-01-2024',
    },
    {
      ctn: 83,
      d: '04-01-2024',
    },
    {
      ctn: 11,
      d: '05-01-2024',
    },
  ];

  allDates$ = new BehaviorSubject([]);
  maxCtnValue = Math.max(...this.activity.map((a) => a.ctn));
  stats: {
    date: string;
    counter: number;
    dayOfWeek: string;
    index: string;
    p: number;
  }[][] = [];
  constructor() {}

  ngOnInit(): void {
    let start = DateTime.fromObject({
      day: 29,
      month: 5,
      year: 2023,
    });
    const allDates: {
      date: string;
      counter: number;
      dayOfWeek: string;
      index: string;
      p: number;
    }[] = [];

    while (start.toSeconds() < DateTime.now().toSeconds()) {
      const counter =
        this.activity.find((a) => a.d === start.toFormat('dd-MM-yyyy'))?.ctn ||
        0;
      allDates.push({
        date: start.toFormat('dd-MM-yyyy'),
        dayOfWeek: start.toFormat('EEE, dd-MM-yyyy'),
        index: start.toFormat('yyyy-W'),
        p: (counter / this.maxCtnValue) * 100,
        counter,
      });

      start = start.plus({ days: 1 });
    }
    console.log(allDates);
    // console.log();
    this.stats = Object.values(groupArrayByIndexMulti(allDates, 'index'));
  }
}
